@if (order?.statusDisplay) {
  <mat-chip-list aria-label="status">
    <mat-chip
      class="order-history-table__tag"
      [ngClass]="orderHistoryService.getOrderStatusColor(order, forceStatus)"
      color="default"
      selected
      >
      {{ order.statusDisplay }}
    </mat-chip>
  </mat-chip-list>
}
